// src/components/SimBanner.tsx
import styles from './SimBanner.module.css';

export function SimBanner() {
  return (
    <div className={styles.banner} role="alert">
      <div className={styles.dot} aria-hidden />
      <p className={styles.text}>
        <strong>AI Simulation</strong> — You are conversing with a digital persona
        built from recorded data, not a real person.
        This system has no consciousness or genuine memory.
      </p>
    </div>
  );
}
